// Default filters values

export const BOAT_CABINS_MIN_VALUE = 0;
export const BOAT_CABINS_MAX_VALUE = 30;

export const DISCOUNT_NAME = '';
export const DISCOUNT_AMOUNT_MIN_VALUE = 0;
export const DISCOUNT_AMOUNT_MAX_VALUE = 100;
